<template>
  <div class="thesis_container">
    <div class="btnBlock">
      <el-button type="success" @click="save(-1)">暂存</el-button>
      <el-button type="warning" @click="save(2)">预览</el-button>
      <el-button type="primary" @click="save(1)">{{
        stype == "chugao" ? "保存并生成初稿论文 " : "提交"
      }}</el-button>
      <el-button type="info" @click="save(3)">下载</el-button>
      <el-button @click="handleClose">返回</el-button>
    </div>
    <div>
      <!-- 导航条 -->
      <ul class="sidebar" v-if="$route.path == '/thesis-edit'">
        <li v-for="(item, i) in menu" :key="item.name" :class="{
          active: 1 === item.active,
          'css-lvmdsl': i != menu.length - 1,
        }">
          <a href="javascript:;" @click="scrollTo(item)">{{ item.name }}</a>
        </li>
      </ul>
    </div>
    <div class="content">
      <!-- 封面 -->
      <div id="fm">
        <div class="tc mt ht fs1">
          <!-- <img src="https://jxjy-att.whxunw.com/upload/20251226/3bf20e9160454662b8d74b6726d80502.png" width="298" alt=""> -->
          <img v-if="infoData.logo" :src="infoData.logo" width="298" height="80" alt="">
          <img v-else-if="schoolInfo.logo" :src="schoolInfo.logo" width="80" height="80" alt="">
        </div>
        <div class="tc st fs2 fb" style="margin: 20px 0 0">
          高等教育自学考试本科毕业论文（设计）
        </div>
        <div class="tc mt ht fs2" style="margin: 8% 0">
          <!-- {{ infoData.title }} -->
          <el-input v-model="infoData.title" style="width: 60%; min-width: 500px" placeholder="请输入论文标题"
            @input="EditChange"></el-input>
        </div>
        <div class="tc btinfo ht fs3">
          <el-row>
            <el-col :span="10">学生姓名：</el-col>
            <el-col :span="14">{{ infoData.userRealNme }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="10">准考证号：</el-col>
            <el-col :span="14">{{ infoData.userUo }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="10">专&emsp;&emsp;业：</el-col>
            <el-col :span="14">{{ infoData.specialtyName }}（{{ infoData.specialtyCode }}）</el-col>
          </el-row>
          <el-row>
            <el-col :span="10">教学站点：</el-col>
            <el-col :span="14">{{ infoData.teachPointName }}&emsp; {{ infoData.teachPointCode }} </el-col>
          </el-row>

          <!-- <el-row>
            <el-col :span="10">课程（课程代码）</el-col>
            <el-col :span="14">{{ infoData.courseName }}（{{infoData.courseCode}}）</el-col>
          </el-row> -->


          <el-row>
            <el-col :span="10">指导教师：</el-col>
            <el-col :span="14">{{ infoData.teacherName }}（职称）</el-col>
          </el-row>
        </div>

        <div class="tc  ht fs3" style="margin: 40px 0 0">
          二〇 {{ infoData.createdDate | dateFormat('yy年MM月') }}
        </div>
        <div class="tc  ht fs3 fb" style="margin: 20px 0">
          {{ infoData.schoolName }}校高等教育自学考试委员会办公室
        </div>
      </div>


      <!-- 声名 -->
      <div>
        <div>
          <div class="tc mt st fs2 fb" style="margin: 20px 0">
            郑 重 声 明
          </div>
          <div class="ti st fs4">
            本人呈交的学位论文，是在导师的指导下，独立进行研究工作所取得的成果，所有数据、图片资料真实可靠。尽我所知，除文中已经注明引用的内容外，本学位论文的研究成果不包含他人享有著作权的内容。对本论文所涉及的研究工作做出贡献的其他个人和集体，均已在文中以明确的方式标明。本学位论文的知识产权归属于培养单位。
          </div>
          <div class="qminfo st fs4">
            <div>
              <div class="label">本人签名：</div>
              <div class="nr">{{ infoData.userRealNme }}</div>
            </div>
            <div>
              <div class="label">日期：</div>
              <div class="nr">{{ infoData.createdDate | dateFormat('yyyy年MM月dd日') }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 摘 要 -->
      <div id="zy">
        <div class="tc mt ht fsx2 fb" style="margin: 20px 0">摘 要</div>
        <div class="st fsx4">
          <!-- <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            placeholder="请输入内容"
            v-model="infoData.thesisAbstract"
            @input="EditChange"
          >
          </el-input> -->
          <Editor class="st fsx4" v-model="infoData.thesisAbstract" id="lwzy" @input="EditChange" />
        </div>
        <div class="df mt dc">
          <div style="width: 70px" class="ht fsx4 fb">关键词：</div>
          <el-input class="st fsx4" size="mini" v-model="infoData.keyword" @input="EditChange"></el-input>
        </div>
      </div>
      <!-- 英文 摘 要 -->
      <el-button @click="ywzyShowChange" plain :type="ywzyShow ? 'danger' : 'primary'"
        style="margin: 10px 0 10px 100%; transform: translateX(-100%)">{{ ywzyShow ? "删除" : "填写" }}英文摘要</el-button>

      <div id="ywzy" v-if="ywzyShow">
        <div class="tc mt tt fs2 fb" style="margin: 20px 0">ABSTRACT</div>
        <div class=" tt fsx4">
          <!-- <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            placeholder="请输入内容"
            v-model="infoData.thesisAbstract"
            @input="EditChange"
          >
          </el-input> -->
          <Editor class="tt  fsx4" v-model="infoData.englishAbstract" id="lwzy_el" @input="EditChange" />
        </div>
        <div class="df mt dc">
          <div style="min-width: 135px" class="tt fsx4 fb">【Key words】：</div>
          <el-input class="tt fsx4" size="mini" v-model="infoData.englishKeyword" @input="EditChange"></el-input>
        </div>
      </div>
      <!-- 目录 -->
      <div id="ml">
        <div class="tc mt ht fsx2 fb" style="margin: 20px 0">目 录</div>
        <div class="st fsx4">
          <!-- <div v-for="(z, zi) in thesisSection" :key="'mz' + zi">
            <div @click="$set(z, 'mshow', !z.mshow)" class="ztitle oe">
              <span class="tup">
                <i class="el-icon-arrow-up" v-if="!z.mshow"></i>
                <i class="el-icon-arrow-down" v-else></i>
              </span>
              第{{ zi + 1 }}章 <span class="ml">{{ z.title }}</span>
            </div>
            <div v-show="!z.mshow">
              <div v-for="(j, ji) in z.children" :key="'mj' + ji">
                <div @click="$set(j, 'mshow', !j.mshow)" class="ztitle oe">
                  <span class="tup" v-if="j.children && j.children.length">
                    <i class="el-icon-arrow-up" v-if="!j.mshow"></i>
                    <i class="el-icon-arrow-down" v-else></i>
                  </span>
                  {{ zi + 1 }}.{{ ji + 1 }}<span class="ml">{{ j.title }}</span>
                </div>
                <div v-show="!j.mshow">
                  <div v-for="(j1, j1i) in j.children" :key="'mj1' + j1i">
                    {{ zi + 1 }}.{{ ji + 1 }}.{{ j1i + 1
                    }}<span class="ml">{{ j1.title }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div v-for="(z, zi) in thesisSection" :key="'mz' + zi">
            <div class="ztitle oe" @click="mscrollTo('qz' + zi)">
              <span>第{{ zi + 1 }}章</span>
              <span class="ml">{{ z.title }}</span>
            </div>
            <div>
              <div v-for="(j, ji) in z.children" :key="'mj' + ji" style="padding-left: 2em">
                <div class="ztitle oe" @click="mscrollTo('qj' + zi + ji)">
                  {{ zi + 1 }}.{{ ji + 1 }}<span class="ml">{{ j.title }}</span>
                </div>
                <div>
                  <div style="padding-left: 2em" v-for="(j1, j1i) in j.children" :key="'mj1' + j1i" class="ztitle oe"
                    @click="mscrollTo('qj' + zi + ji + j1i)">
                    {{ zi + 1 }}.{{ ji + 1 }}.{{ j1i + 1
                    }}<span class="ml">{{ j1.title }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文章节 -->
      <div class="zhengwen" id="zw">
        <div v-for="(z, zi) in thesisSection" :key="zi" class="zhang" :id="'qz' + zi">
          <div class="z-title ht fsx2">
            <div class="dc" style="margin: auto">
              <div class="z-index" style="font-weight: 700">
                第{{ zi + 1 }}章
              </div>
              <el-input size="mini" placeholder="请输入标题" v-model="z.title" style="width: 360px"
                @input="EditChange"></el-input>
            </div>
            <div class="zbtn">
              <el-tooltip content="收起" placement="top" effect="light" v-if="!z.show">
                <el-button icon="el-icon-arrow-up" circle size="mini" @click="$set(z, 'show', !z.show)"></el-button>
              </el-tooltip>
              <el-tooltip content="展开" placement="top" effect="light" v-else>
                <el-button icon="el-icon-arrow-down" circle size="mini" @click="$set(z, 'show', !z.show)"></el-button>
              </el-tooltip>
              <el-dropdown size="mini" type="primary" @command="e => handleCommand('1', thesisSection, e, zi)"
                style="margin-left: 10px">
                <el-button type="primary" icon="el-icon-more" circle size="mini"></el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item
                    command="add"
                    v-if="zi == thesisSection.length - 1"
                    >添加正文</el-dropdown-item
                  > -->
                  <el-dropdown-item command="addz">添加子标题</el-dropdown-item>
                  <el-dropdown-item command="del" v-if="thesisSection.length > 1">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button class="ml" icon="el-icon-edit" type="primary" size="mini"
                @click="$set(z, 'editShow', true)">正文</el-button>
              <!-- <el-tooltip content="新增章节" placement="top" effect="light">
                <el-button
                  type="primary"
                  icon="el-icon-plus"
                  circle
                  size="mini"
                ></el-button>
              </el-tooltip>

              <el-tooltip content="删除" placement="top" effect="light">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="mini"
                ></el-button>
              </el-tooltip> -->
            </div>
          </div>
          <div class="fwb" v-if="z.editShow">
            <Editor class="st fsx4 mt" v-model="z.content" :id="'z' + zi" @input="EditChange" />
            <el-button type="danger" size="mini" @click="delEdit(z)">删除</el-button>
          </div>
          <div v-show="!z.show">
            <div v-for="(j, ji) in z.children" :key="ji" class="zhang" :id="'qj' + zi + ji">
              <div class="z-title ht fs3 p1">
                <div class="z-index" style="width: 50px">
                  {{ zi + 1 }}.{{ ji + 1 }}
                </div>
                <el-input size="mini" placeholder="请输入标题" v-model="j.title" @input="EditChange"></el-input>
                <div class="zbtn">
                  <el-tooltip content="收起" placement="top" effect="light" v-if="!j.show">
                    <el-button icon="el-icon-arrow-up" circle size="mini" @click="$set(j, 'show', !j.show)"></el-button>
                  </el-tooltip>
                  <el-tooltip content="展开" placement="top" effect="light" v-else>
                    <el-button icon="el-icon-arrow-down" circle size="mini"
                      @click="$set(j, 'show', !j.show)"></el-button>
                  </el-tooltip>
                  <el-dropdown size="mini" type="primary" @command="e => handleCommand('2', z.children, e, ji)"
                    style="margin-left: 10px">
                    <el-button type="primary" icon="el-icon-more" circle size="mini"></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="add" v-if="ji == z.children.length - 1">添加同级标题</el-dropdown-item>
                      <el-dropdown-item command="addz">添加子标题</el-dropdown-item>
                      <el-dropdown-item command="del">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-button class="ml" icon="el-icon-edit" type="primary" size="mini"
                    @click="$set(j, 'editShow', true)">正文</el-button>
                </div>
              </div>
              <div class="fwb" v-if="j.editShow">
                <Editor class="st fsx4 mt" v-model="j.content" :id="'j' + zi + ji" @input="EditChange" />
                <el-button type="danger" size="mini" @click="delEdit(j)">删除</el-button>
              </div>
              <div v-show="!j.show">
                <div v-for="(j1, j1i) in j.children" :key="j1i" class="zhang" :id="'qj' + zi + ji + j1i">
                  <div class="z-title ht fs4 p2">
                    <div class="z-index">
                      {{ zi + 1 }}.{{ ji + 1 }}.{{ j1i + 1 }}
                    </div>
                    <el-input size="mini" placeholder="请输入标题" v-model="j1.title" @input="EditChange"></el-input>

                    <div class="zbtn">
                      <!-- <el-tooltip
                        content="收起"
                        placement="top"
                        effect="light"
                        v-if="!j1.show"
                      >
                        <el-button
                          icon="el-icon-arrow-up"
                          circle
                          size="mini"
                          @click="$set(j1, 'show', !j1.show)"
                        ></el-button>
                      </el-tooltip>
                      <el-tooltip
                        content="展开"
                        placement="top"
                        effect="light"
                        v-else
                      >
                        <el-button
                          icon="el-icon-arrow-down"
                          circle
                          size="mini"
                          @click="$set(j1, 'show', !j1.show)"
                        ></el-button>
                      </el-tooltip> -->
                      <el-dropdown size="mini" type="primary" @command="e => handleCommand('3', j.children, e, j1i)"
                        style="margin-left: 10px">
                        <el-button type="primary" icon="el-icon-more" circle size="mini"></el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="add" v-if="j1i == j.children.length - 1">添加同级标题</el-dropdown-item>
                          <el-dropdown-item command="del">删除</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-button class="ml" icon="el-icon-edit" type="primary" size="mini"
                        @click="$set(j1, 'editShow', true)">正文</el-button>
                    </div>
                  </div>
                  <div class="fwb" v-if="j1.editShow">
                    <Editor class="st fsx4 mt" v-model="j1.content" :id="'j' + zi + ji + j1i" @input="EditChange" />
                    <el-button type="danger" size="mini" @click="delEdit(j1)">删除</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="text-align: center; margin-top: 10px">
          <el-button style="margin: auto" type="primary" plain @click="addZhang()">添加第{{ thesisSection.length + 1
            }}章</el-button>
        </div>
      </div>
      <!-- 参考文献 -->
      <div id="ck">
        <div class="tc mt ht fsx2 fb" style="margin: 20px 0">参考文献</div>
        <div>
          <Editor class="st fsx4" v-model="infoData.reference" id="ckwx" @input="EditChange" />
        </div>
      </div>

      
      <!-- 致谢 -->
      <div id="zx">
        <div class="tc mt ht fsx2 fb" style="margin: 20px 0">致 谢</div>
        <div>
          <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入内容" v-model="infoData.thank"
            class="st fsx4" @input="EditChange">
          </el-input>
        </div>
      </div>
      <!-- 附录 -->
      <el-button @click="flShowChange" plain :type="flShow ? 'danger' : 'primary'"
        style="margin: 10px 0 10px 100%; transform: translateX(-100%)">{{ flShow ? "删除" : "填写" }}附录</el-button>
      <div id="fl" v-if="flShow">
        <div class="tc mt ht fsx2 fb" style="margin: 20px 0">附 录</div>
        <div class="st fsx4">
          <Editor class="st fsx4" v-model="infoData.addition" id="fulu" @input="EditChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    Editor: () => import("@/components/Editors.vue"),
  },
  data() {
    return {
      visible: false,
      infoData: {},
      thesisSection: [],
      menu: [
        {
          name: "封面",
          id: "fm",
          active: 0,
        },
        {
          name: "摘要",
          id: "zy",
          active: 0,
        },
        {
          name: "目录",
          id: "ml",
          active: 0,
        },
        {
          name: "正文",
          id: "zw",
          active: 0,
        },
        {
          name: "参考文献",
          id: "ck",
          active: 0,
        },
        {
          name: "致谢",
          id: "zx",
          active: 0,
        },
      ],
      isDq: false,
      isChange: false,
      thesisId: "",
      setIn: null,
      isCre: true,
      stype: "",
      currentUserId: this.$store.state.user.userId,
      isSub: false,
      ywzyShow: false,
      flShow: false,
      loadingModel: null
    };
  },
  computed: {
    ...mapState(["thesis", 'schoolInfo']),
  },
  created() {
    this.isDq = true;
    this.thesisId = this.$route.query.thesisId;
    this.stype = this.$route.query.stype;
    this.getInfo();
    const _t = this;
    this.setIn = setInterval(() => {
      if (_t.isChange) {
        _t.save();
      }
    }, 60 * 1000);
  },
  mounted() {
    this.menu.forEach(item => {
      item.offsetTop = document.getElementById(item.id).offsetTop;
      item.scrollHeight = document.getElementById(item.id).scrollHeight;
    });
    // 监听滚动事件
    window.addEventListener("scroll", this.onScroll);
  },
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener("scroll", this.onScroll);
    if (this.isChange) this.save();
    this.isDq = false;
    if (this.setIn) {
      clearInterval(this.setIn);
      this.setIn = null;
    }
  },
  methods: {
    getInfo() {
      const _t = this;
      this.$http
        .post("/student/thesis2/init", { thesisId: this.thesisId }, { isQs: 1 })
        .then(res => {
          if (res) {
            _t.infoData = res;
            const _ld = localStorage.getItem(this.thesisId);
            if (_ld) {
              const ld = JSON.parse(_ld);
              if (
                !res.lastUpdateDate ||
                (ld.upTime && ld.upTime > res.lastUpdateDate)
              ) {
                _t.infoData = ld;
                const thesisSection = (ld && ld.thesisSection) || [];
                _t.thesisSection = _t.getChildren(thesisSection);
              } else {
                const thesisSection = (res && res.thesisSection) || [];
                _t.thesisSection = _t.getChildren(thesisSection);
              }
            } else {
              const thesisSection = (res && res.thesisSection) || [];
              _t.thesisSection = _t.getChildren(thesisSection);
            }
            if (_t.infoData.englishAbstract || _t.infoData.englishKeyword) {
              this.ywzyShow = true;
            }
            if (_t.infoData.addition) {
              this.flShow = true;
            }
            setTimeout(() => {
              _t.isCre = false;
            }, 1000);
          }
        });
    },
    getChildren(data) {
      return data.map(e => {
        if (e.children && e.children.length) {
          e.children = this.getChildren(e.children);
        }
        return { ...e, editShow: !!e.content };
      });
    },
    open(res) {
      this.infoData = {};
      this.visible = true;
    },
    handleClose() {
      if (this.isChange) this.save();
      this.isChange = false;
      if (this.setIn) {
        clearInterval(this.setIn);
        this.setIn = null;
      }
      this.$router.go(-1);
    },
    save(isSubmit = 0) {
      const _t = this
      if (isSubmit == 1) {
        if (!this.infoData.title) {
          this.$message({
            showClose: true,
            message: "请填写论文标题。",
            type: "error",
          });
          return;
        }
        if (!this.infoData.thesisAbstract) {
          this.$message({
            showClose: true,
            message: "请填写摘要。",
            type: "error",
          });
          return;
        }
        if (!this.infoData.keyword) {
          this.$message({
            showClose: true,
            message: "请填写关键词。",
            type: "error",
          });
          return;
        }
        if (this.infoData.englishKeyword && !this.infoData.englishAbstract) {
          this.$message({
            showClose: true,
            message: "请填写Abstract。",
            type: "error",
          });
          return;
        }
        if (!this.infoData.englishKeyword && this.infoData.englishAbstract) {
          this.$message({
            showClose: true,
            message: "请填写Key words。",
            type: "error",
          });
          return;
        }
        if (!(this.thesisSection && this.thesisSection.length)) {
          this.$message({
            showClose: true,
            message: "请填写正文。",
            type: "error",
          });
          return;
        }
        if (!this.isthesisSectionOk()) {
          return;
        }
        if (!this.infoData.reference) {
          this.$message({
            showClose: true,
            message: "请填写参考文献。",
            type: "error",
          });
          return;
        }

        if (!this.infoData.thank) {
          this.$message({
            showClose: true,
            message: "请填写致谢。",
            type: "error",
          });
          return;
        }
      }
      if (isSubmit) {
        this.loadingModel = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
        });
      }
      let _s = isSubmit > 0 ? 1 : 0;
      const infoData = {
        ...this.infoData,
        thesisSection: this.thesisSection,
      };
      this.$http
        .post_s(
          `/student/thesis2/${this.thesisId || ""}/${_s}/saveOrSubmit`,
          // {json:JSON.stringify(infoData)}
          JSON.stringify(infoData),
          // ,{isQs:1}
        )
        .then(res => {
          this.isChange = false;
          if (isSubmit == 1) {
            if (this.stype == "chugao") {
              this.saveChugao(res);
            } else if (this.stype == "submitToAudit") {
              this.submitToAudit_b(res);
            } else if (this.stype == "submitToAudit6") {
              localStorage.setItem(
                _t.currentUserId + "retdata",
                JSON.stringify(res)
              );
              _t.close();
            } else if (this.stype == "cj_submitToAudit") {
              this.submitToAuditb(res);
            } else if (this.stype == 'finalThesis') {
              this.reloadFinalThesis(res);
            }
          } else if (isSubmit == 2) {
            window.open(
              `https://view.officeapps.live.com/op/view.aspx?src=${res.fullpath}`
            );
          } else if (isSubmit == 3) {
            window.open(res.fullpath);
          }
        })
        .catch(() => { })
        .finally(() => {
          this.isSub = false;
          this.loadingModel.close()
        });
    },
    reloadFinalThesis(opt) {
      const _t = this
      const params = {
        url: opt.fullpath,
        size: opt.fileSize,
        thesisBatchId: this.infoData.tid
      }
      this.$http.post("/student/thesis2/saveZhongGao", params).then(res => {
        if (res) {
          this.$message({
            showClose: true,
            message: "提交成功，等待指导老师审核。",
            type: "success",
          });
          _t.close();
        }
      });
    },
    isthesisSectionOk() {
      let ret = true;
      let z = 0;
      let j = 0;
      let j1 = 0;
      this.thesisSection.some((e, zi) => {
        if (!e.title) {
          z = zi + 1;
          ret = false;
          return true;
        } else {
          if (e.children && e.children.length) {
            return e.children.some((je, ji) => {
              if (!je.title) {
                z = zi + 1;
                j = ji + 1;
                ret = false;
                return true;
              } else {
                if (je.children && je.children.length) {
                  return je.children.some((j1e, j1i) => {
                    if (!j1e.title) {
                      z = zi + 1;
                      j = ji + 1;
                      j1 = j1i + 1;
                      ret = false;
                      return true;
                    }
                  });
                }
              }
            });
          }
        }
      });
      if (!ret) {
        let tic = "";
        if (j1) {
          tic = `${z}.${j}.${j1}`;
        } else if (j) {
          tic = `${z}.${j}`;
        } else if (z) {
          tic = `第${z}章`;
        }
        this.$message({
          showClose: true,
          message: `正文：${tic} 标题为空，请填写后再提交`,
          type: "error",
        });
      }
      return ret;
    },
    submitToAuditb(res) {
      const params = {
        thesisId: this.thesisId,
        name: this.thesis.name,
        email: this.thesis.email,
        attPath: res.fullpath,
        attSize: res.fileSize,
        remark: this.thesis._submitToAuditremark,
        isSpotCheck: 1,
      };
      const _t = this;
      _t.$http.post("/student/thesis2/submitToAudit", params, { isQs: 1 }).then(res => {
        if (res) {
          this.$message({
            showClose: true,
            message: "提交成功，等待指导老师审核。",
            type: "success",
          });
          _t.close();
        }
      });
    },
    submitToAudit_b(res) {
      const params = {
        attPath: res.fullpath,
        attSize: res.fileSize,
        attName: res.filename,
        thesisId: this.thesisId,
      };
      if (this.thesis.remark) {
        params.remark = this.thesis.remark
      }
      const _t = this;
      _t.$http.post("/student/thesis2/submitToAudit", params, { isQs: 1 }).then(res => {
        if (res) {
          this.$message({
            showClose: true,
            message: "提交成功，等待指导老师审核。",
            type: "success",
          });
          _t.close();
        }
      });
    },
    close() {
      if (this.setIn) {
        clearInterval(this.setIn);
        this.setIn = null;
      }
      this.$router.go(-1);
    },
    saveChugao(res) {
      const params = {
        chugaoUrl: res.fullpath,
        chugaoSize: res.fileSize,
        thesisBatchId: this.infoData.tid,
        name: this.thesis.name,
        isDegree: this.thesis.isDegree,
        email: this.thesis.email,
        teacherId: this.thesis.teacherId,
      };
      const _t = this
      this.$http.post("/student/thesis2/saveChugao", params, { isQs: 1 }).then(res => {
        if (res) {
          this.$confirm(
            "初稿论文已经成功生成，请考生查重后再提交给指导老师审核。",
            "提示",
            {
              confirmButtonText: "确定",
              type: "warning",
            }
          )
            .then(() => {
              _t.close();
            })
            .catch(() => { });
        }
      });
    },
    handleCommand(j, list, t, zi) {
      if (t == "add") {
        list.push({
          title: "",
          content: "",
          children: [],
        });
      } else if (t == "addz") {
        if (!list[zi].children) {
          list[zi].children = [];
        }
        list[zi].children.push({
          title: "",
          content: "",
          children: [],
        });
      } else if (t == "del") {
        list.splice(zi, 1);
      }
      this.EditChange();
    },
    addZhang() {
      this.thesisSection.push({
        title: "",
        content: "",
        children: [],
      });
      this.EditChange();
    },
    // 滚动监听器
    onScroll() {
      // 获取浏览器窗口高度
      let clientHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
      // 获取当前文档流的 scrollTop
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 屏幕垂直中线
      let screenMiddle = scrollTop + clientHeight / 2;
      this.menu.forEach(item => {
        //以浏览器窗口垂直中线为准，中线在内容模块的上边界至下边界之间，导航栏都认为在该楼层
        if (
          screenMiddle - item.offsetTop >= 0 &&
          screenMiddle - item.offsetTop < item.scrollHeight
        ) {
          item.active = 1;
        } else {
          item.active = 0;
        }
      });
    },
    // 跳转到指定索引的元素
    scrollTo(item) {
      // 获取目标的 offsetTop
      // css选择器是从 1 开始计数，我们是从 0 开始，所以要 +1
      const targetOffsetTop = document.getElementById(item.id).offsetTop;
      // 获取当前 offsetTop
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉，步子迈大了会扯到蛋
      const STEP = 50;
      // 判断是往下滑还是往上滑
      if (scrollTop > targetOffsetTop) {
        // 往上滑
        smoothUp();
      } else {
        // 往下滑
        smoothDown();
      }
      // 定义往下滑函数
      function smoothDown() {
        // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
        if (scrollTop < targetOffsetTop) {
          // 如果和目标相差距离大于等于 STEP 就跳 STEP
          // 否则直接跳到目标点，目标是为了防止跳过了。
          if (targetOffsetTop - scrollTop >= STEP) {
            scrollTop += STEP;
          } else {
            scrollTop = targetOffsetTop;
          }
          document.body.scrollTop = scrollTop;
          document.documentElement.scrollTop = scrollTop;
          // 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
          requestAnimationFrame(smoothDown);
        }
      }
      // 定义往上滑函数
      function smoothUp() {
        if (scrollTop > targetOffsetTop) {
          if (scrollTop - targetOffsetTop >= STEP) {
            scrollTop -= STEP;
          } else {
            scrollTop = targetOffsetTop;
          }
          document.body.scrollTop = scrollTop;
          document.documentElement.scrollTop = scrollTop;
          requestAnimationFrame(smoothUp);
        }
      }
    },
    mscrollTo(id) {
      const anchorEle = document.querySelector("#" + id);
      anchorEle.scrollIntoView();
    },
    delEdit(e) {
      if (e.content) {
        this.$confirm("删除将会清空当前文本内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$set(e, "editShow", false);
            this.$set(e, "content", "");
            this.EditChange();
          })
          .catch(() => { });
      } else {
        this.$set(e, "editShow", false);
        this.$set(e, "content", "");
        this.EditChange();
      }
    },
    EditChange(e) {

      if (this.isCre) {
        return;
      }
      const _t = this;
      _t.isChange = true;
      const infoData = {
        ..._t.infoData,
        thesisSection: _t.thesisSection,
        upTime: new Date().getTime(),
      };
      _t.debounce(() => {
        localStorage.setItem(this.thesisId, JSON.stringify(infoData));
      }, 2000);
    },
    debounce(fn, t) {
      let timer = null;
      return (function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          fn();
        }, t);
      })();
    },
    ywzyShowChange() {
      if (this.ywzyShow) {
        if (this.infoData.englishKeyword || this.infoData.englishAbstract) {
          this.$confirm("删除将会清空当前文本内容, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$set(this.infoData, "englishKeyword", "");
              this.$set(this.infoData, "englishAbstract", "");
              this.ywzyShow = false;
            })
            .catch(() => { });
        } else {
          this.ywzyShow = false;
        }
      } else {
        this.ywzyShow = true;
      }
    },
    flShowChange() {
      if (this.flShow) {
        if (this.infoData.addition) {
          this.$confirm("删除将会清空当前文本内容, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$set(this.infoData, "addition", "");
              this.flShow = false;
            })
            .catch(() => { });
        } else {
          this.flShow = false;
        }
      } else {
        this.flShow = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.thesis_container {
  padding: 15px;
  overflow-x: hidden;
  background: #fff;

  .btnBlock {
    position: fixed;
    z-index: 2;
    left: 10px;
    top: calc(10% + 250px);
    width: 158px;

    &>* {
      display: block;
      width: 100%;
      margin: 10px;
    }
  }

  .content {
    width: 70%;
    min-width: 504px;
    margin: auto;
  }

  .zhengwen {
    margin-top: 20px;
  }

  .zhang {
    margin-top: 10px;

    .z-title {
      margin-top: 12px;
      display: flex;
      position: relative;
      align-items: center;

      .z-index {
        display: inline-block;
        width: 100px;
      }

      .el-input {
        display: inline-block;
      }

      .zbtn {
        position: absolute;
        left: calc(100% + 10px);
        width: 100%;
      }
    }
  }

  #ml {
    .ztitle {
      // border-radius: 5px;
      // background: #f5f5f5;
      // padding: 5px;
      cursor: pointer;

      .tup {
        display: inline-block;
        width: 20px;
      }
    }

    .oe {
      overflow: hidden;
      /* 确保溢出的内容被隐藏 */
      white-space: nowrap;
      /* 确保文本在一行内显示 */
      text-overflow: ellipsis;
      /* 使用省略符号表示文本溢出 */
    }
  }

  .ml {
    margin-left: 10px;
  }

  .dc {
    display: flex;
    align-items: center;
  }

  .fwb {
    position: relative;

    .el-button {
      position: absolute;
      left: calc(100% + 5px);
      top: 0;
    }
  }

  .p1 {
    // padding-left: 15px;
  }

  .p2 {
    // padding-left: 30px;
  }

  #ml {
    border: 1px dashed #ccc;
    padding: 10px 20px;
    min-height: 500px;
    margin-top: 20px;
    border-radius: 5px;
    line-height: 30px;
  }
}

.tc {
  text-align: center;
}

.tr {
  text-align: right;
}

.mt {
  margin-top: 10px;
}

.ti {
  text-indent: 2em;
}

.qm {
  margin-top: 10px;

  &>.el-input:first-child {
    width: 100px;
    display: inline-block;
  }
}

.df {
  display: flex;
}

.qmDate {
  // width: 150px;
  margin-left: 5px;
  display: inline-block;
}

.btinfo {
  width: 100%;
  margin: 20px auto;

  &>div {
    width: 100%;
    display: flex;
    justify-content: center;

    &>div {
      // border: 1px dashed #ccc;
      padding: 10px;
      border-top: none;
    }

    &>div:first-child {
      border-right: none !important;
      text-align: right;
      width: 150px;
    }

    &>div:last-child {
      border-bottom: 1px solid #ccc !important;
    }
  }

  &>div:first-child>div {
    // border: 1px dashed #ccc;
  }
}

.sidebar {
  position: fixed;
  z-index: 2000;
  top: 10%;
  left: 15px;
  width: 168px;
  overflow: hidden;
  background-color: #fff;
  border-radius: 8px;
  padding: 0;
  // transform: translateY(-50%);
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.05),
    0px 3px 5px 0px rgba(0, 0, 0, 0.06), 0px 2px 4px -1px rgba(0, 0, 0, 0.04);

  li {
    line-height: 40px;
    // text-align: center;
    list-style: none;
    padding-left: 30px;

    // &:not(:last-child) {
    //   border-bottom: #f5f5f5 solid 1px;
    // }
    //侧边导航选中颜色
    &.active a {
      // color: #fff;
      // background-color: #ff8000;
      color: rgb(23, 114, 246) !important;
    }

    &:hover {
      a {
        color: rgb(23, 114, 246);
      }

      background: rgb(235, 236, 237);
      border-radius: 4px;
    }

    a {
      display: block;
      width: 100%;
      height: 100%;
      color: rgb(132, 145, 165);
      text-decoration: none;
    }

    position: relative;

    &::before {
      left: 16px;
      width: 6px;
      height: 6px;
      content: " ";
      position: absolute;
      background-color: rgb(132, 145, 165);
      display: inline-block;
      border-radius: 50%;
      top: 16px;
      margin-right: 12px;
    }
  }

  .css-lvmdsl::after {
    content: " ";
    display: block;
    position: absolute;
    left: 19px;
    top: 4px;
    transform: translateX(-50%);
    width: 2px;
    height: 40px;
    margin-top: 12px;
    background: rgba(132, 145, 165, 0.12);
  }
}
.qminfo{
  display: flex;
  width: 80%;
  margin:20px auto ;
  >div{
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .label{
    width: 100px;
    text-align: right;
    margin-right: 10px;
  }
  .nr{
    border-bottom: 1px solid ;
    width: calc(100% - 100px);
    text-align: center;
  }
}




// 一号
.fs1 {
  font-size: 26pt !important;
}

// 二号
.fs2 {
  font-size: 22pt !important;
}

// 三号
.fs3 {
  font-size: 16pt !important;
}

// 四号
.fs4 {
  font-size: 14pt !important;
}

// 五号
.fs5 {
  font-size: 10.5pt !important;
}

// 小一号
.fsx1 {
  font-size: 24pt !important;
}

// 小二号
.fsx2 {
  font-size: 18pt !important;
}

// 小三号
.fsx3 {
  font-size: 15pt !important;
}

// 小四号
.fsx4 {
  font-size: 12pt !important;
}

// 华文中宋
.hwzs {
  font-family: "华文中宋", "STZhongsong", serif !important;
}

// 黑体
.ht {
  font-family: "SimHei", "Hei", "STHeiti", sans-serif !important;
}

// 宋体
.st {
  font-family: "SimSun", "宋体", "STSong", sans-serif !important;
}

.tt {
  font-family: 'Times New Roman', Times, serif;
}

.fb {
  font-weight: bold;
}
</style>
